import getInstance from "../config/api";

export default class CredenciadaCode {
  static async fetchAccessCredenciadaCode(params) {
    const instance = getInstance();
    const { data } = await instance.get("/consolidated/redeFacil", { params });
    return data;
  }
}
